// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubSelectedService {
    static getAttributeTypeMap() {
        return MangoHubSelectedService.attributeTypeMap;
    }
}
MangoHubSelectedService.discriminator = undefined;
MangoHubSelectedService.additionalProperties = false;
MangoHubSelectedService.attributeTypeMap = [
    {
        "name": "serviceCode",
        "baseName": "serviceCode",
        "type": "string"
    },
    {
        "name": "serviceDescription",
        "baseName": "serviceDescription",
        "type": "string"
    },
];
//# sourceMappingURL=mangoHubSelectedService.js.map